import { render, staticRenderFns } from "./productImageInfo.vue?vue&type=template&id=5a6110b6&scoped=true&"
import script from "./productImageInfo.vue?vue&type=script&lang=js&"
export * from "./productImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./productImageInfo.vue?vue&type=style&index=0&id=5a6110b6&prod&scoped=true&lang=less&"
import style1 from "./productImageInfo.vue?vue&type=style&index=1&id=5a6110b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6110b6",
  null
  
)

export default component.exports